import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { GetQuoteWithFeeAction, GetQuoteWithoutFeeAction } from 'store/types';
import {
  GetQuoteInput,
  GetQuoteOutput,
  QuoteDirection,
  TransactionFeeType,
  TransactionTypeForFee,
} from 'types';

interface IInitialQuoteV2Slice {
  quoteInput: GetQuoteInput;
  quoteDirection: QuoteDirection;
  feeIncludeType: boolean;
  quoteResult: GetQuoteOutput;
  error: any;
}

const initialState: IInitialQuoteV2Slice = {
  quoteInput: {
    from: '',
    to: '',
    fromAmount: 0,
    toAmount: 0,
    transactionType: TransactionTypeForFee.RETAIL_ON_RAMP,
  },
  quoteDirection: QuoteDirection.FROM,
  feeIncludeType: false,
  quoteResult: {
    from: '',
    to: '',
    fromAmount: 0,
    toAmount: 0,

    feeAmount: 0,
    gatewayFee: 0,
    feeCurrency: '',

    liquidityProvider: '',
    rate: 0,
  },
  error: null,
};

const quoteV2Slice = createSlice({
  name: 'quoteV2',
  initialState,
  reducers: {
    getQuoteWithoutFee(state, action: PayloadAction<GetQuoteWithoutFeeAction>) {
      state.quoteInput = action.payload.input;
      state.quoteDirection = action.payload.direction;
    },
    getQuoteWithoutFeeSuccess(state, action: PayloadAction<GetQuoteOutput>) {
      state.quoteResult = action.payload;
    },
    getQuoteWithoutFeeFailure(state, action) {},

    getQuoteWithFee(state, action: PayloadAction<GetQuoteWithFeeAction>) {
      state.quoteInput = action.payload.input;
      state.quoteDirection = action.payload.direction;
      state.feeIncludeType =
        action.payload.input.feeType === TransactionFeeType.INCLUDE;
    },
    getQuoteWithFeeSuccess(state, action: PayloadAction<GetQuoteOutput>) {
      state.quoteResult = action.payload;
    },
    getQuoteWithFeeFailure(state, action) {},

    setFeeIncludeType(state, action: PayloadAction<boolean>) {
      state.feeIncludeType = action.payload;
    },
  },
});

export const actions = quoteV2Slice.actions;
export const reducer = quoteV2Slice.reducer;
